import { apiBaseUrls } from '@saucelabs/sl-util-config';
import TestObjectClient from '@saucelabs/web-rdc-client';

export const connectDevice = ({ deviceSessionId, elementId }) => {
  const url = apiBaseUrls.rdc;
  return TestObjectClient.connectDevice(url, deviceSessionId, elementId);
};
